__turbopack_context__.v({
  "checkbox": "AriaCheckbox-module__BckcaG__checkbox",
  "checkboxContainer": "AriaCheckbox-module__BckcaG__checkboxContainer",
});
